import {EntityClickEvent} from "../../../core/models/events/entity-click-event";

export class CompetitionsSliderEntityClickEvent extends EntityClickEvent {
  entityId: String;
  competitionId: Number;
  sportTypeId: Number;
  widgetType: String;
  partner: String;
  screenResolution: String;

  constructor(params: CompetitionsSliderEntityClickEvent) {
    super('', 'click', 'entity','slider');

    this.entityId = params.entityId;
    this.competitionId = params.competitionId;
    this.sportTypeId = params.sportTypeId;
    this.widgetType = params.widgetType;
    this.partner = params.partner;
    this.screenResolution = params.screenResolution;
  }

  get properties() {
    const properties = super.properties;

    properties.entityId = this.entityId;
    properties.competitionId = this.competitionId;
    properties.sportTypeId = this.sportTypeId;
    properties.widgetType = this.widgetType;
    properties.partner = this.partner;
    properties.screenResolution = this.screenResolution;
    properties.screen = null;
    properties.screenId = null;

    return properties;
  }
}
